//event listeners for viewSwitcher
$(function () {


  //view is set onload cookie check in php
  $(document).on('touchend click','.showGalleryView',function(){
    //ck.displayHiddenCards();
    $('body').removeClass('textOnlyList');
    $('body').addClass('listShowCart listShowDetails');
    $('.expandAllCards').removeClass('toggled');
    $('.zoomedWrapper').removeClass('zoomedWrapper').find('.cardLink').removeClass('zoomed').find('.catalogItemMag').remove('.catalogItemMag');
    $('.zoomItem').removeClass('zoomItem');

    //append query param to url
    let url = window.location.href;
    url = ck.addUrlParam(url, 'view', 'gallery');
    document.location = url;

    ck.setCookie('viewType', 'listShowCart listShowDetails',365);
  });
  $(document).on('touchend click','.showDetailView',function(){
    //ck.displayHiddenCards();
    $('body').removeClass('listShowCart listShowDetails textOnlyList');
    $('.expandAllCards').removeClass('toggled');
    $('.zoomedWrapper').removeClass('zoomedWrapper').find('.cardLink').removeClass('zoomed').find('.catalogItemMag').remove('.catalogItemMag');
    ck.setCookie('viewType', '',365);

    let url = window.location.href;
    url = ck.addUrlParam(url, 'view', 'detail');
    document.location = url;

  });
  $(document).on('touchend click','.showTextView',function(){
    $('body').removeClass('listShowCart listShowDetails');
    $('.expandAllCards').removeClass('toggled');
    $('.zoomedWrapper').removeClass('zoomedWrapper').find('.cardLink').removeClass('zoomed').find('.catalogItemMag').remove('.catalogItemMag');
    $('.zoomItem').removeClass('zoomItem');
    $('body').addClass('textOnlyList');
    ck.setCookie('viewType', 'textOnlyList',365);

    let url = window.location.href;
    url = ck.addUrlParam(url, 'view', 'text');
    document.location = url;
  });
});